<template>
  <modal
    name="addteammodal"
    width="70%"
    :minHeight="300"
    :minWidth="200"
    :maxWidth="800"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-between pt-3">
        <h4>Add New Team</h4>
        <button type="button" @click="closeModal" class="close">
          <span aria-hidden="true"
            ><font-awesome-icon icon="times" size="1x"
          /></span>
        </button>
      </div>

      <div class="d-flex flex-column h-100">
        <div class="row mt-4">
          <div class="col-12 col-md-5 form-group edit-modal-item">
            <span class="cus-label">Team name</span>
            <input type="text" v-model="teamName" placeholder="" required />
          </div>
        </div>

        <div class="row justify-content-end align-items-end button-container">
          <button
            type="submit"
            class="save_btn hover-dark"
            v-on:click.stop="addTeam"
          >
            Add Team
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { addTeam } from "../../../utils/api";
import { mapGetters, mapState } from "vuex";
export default {
  name: "AddTeamModal",
  data() {
    return {
      teamName: ""
    };
  },
  computed: {
    ...mapState(["officeTeamsAll"]),
    ...mapGetters(["getFirstEmployeeId"])
  },
  methods: {
    async addTeam() {
      if (!this.teamName) {
        this.$swal({
          title: "Enter team name."
        });
        return;
      }

      let params = {
        team: {
          name: this.teamName
        }
      };

      let loader = this.$loading.show();
      addTeam(params, this.getFirstEmployeeId)
        .then(response => {
          if (response.data && response.data.data) {
            loader.hide();
            this.teamName = "";
            this.closeModal();
            this.$root.$emit("onGetOfficeTeams");
            this.$root.$emit("onGetOfficeEmployees");
          }
        })
        .catch(err => {
          loader.hide();
        });
    },
    closeModal() {
      this.$modal.hide("addteammodal");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.button-container {
  margin-top: 200px;
}

h2 {
  font-size: 14px;
  font-weight: normal;
  color: #707070;
}

.modal--container {
  padding: 18px 30px;
  overflow-y: auto;
  height: 100%;
}

.close {
  color: #000000;
}

.cus-label {
  font-size: 14px;
  font-weight: normal;
  font-family: "Helvetica Neue";
  color: #000;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/Teams/AddTeamModal.vue